import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { Profile } from 'src/app/models/profile';
import { ProvileVM } from 'src/app/models/requests/ProfileVM';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-profileaccount',
  templateUrl: './profileaccount.component.html',
  styleUrls: ['./profileaccount.component.css']
})
export class ProfileaccountComponent implements OnInit {

  currentUser: any;
  firstName: string = ''
  Doa: string = ''
  locationName: string = ''
  available: string = ''
  startDate:Date[] = [];
  EndDate:Date[] = [];
  lastName: string = ''
  phoneNumber: string = ''
  DepartmentName: string = ''
  DesignationName: string = ''
  isNotAvailableVisible:boolean=false;
  isAway:boolean=false;
  isAwayVisible:boolean=false;

  FunctionName: string = ''
  email: string = ''
  Managers:Profile[]=[];
  DoaId:string="";

  Band: string = '';
  
  availability = [
    { name: "Yes"},
    {  name: "No"}
 ];


  constructor(private tokenService: TokenService,  private userService: UserService, private notification: NotificationService,) { }

  ngOnInit(): void {
    this.loaduser()
  }

  onChangeAvailability(event:string)
  {
   ;

   this.isAway = false;
   const band:string=(event);
   if(event ==""){
     this.isNotAvailableVisible=false;
    }
   let item = this.availability.find(i => i.name === band);
   if(item?.name=== "No")
   {
     this.isNotAvailableVisible=true;
     this.isAwayVisible = false
   }

   if(item?.name=== "Yes")
   {
     this.isNotAvailableVisible=false;
     this.isAwayVisible = false
   }


}

 async loaduser(){
    ;
    this.currentUser = this.tokenService.getInfo();
    this.currentUser = this.tokenService.getInfo();
    this.firstName = this.currentUser.profile.firstName
    this.lastName = this.currentUser.profile.lastName
    this.FunctionName = this.currentUser.profile.functionName 
    this.locationName = this.currentUser.profile.locationName  
    this.DesignationName = this.currentUser.profile.designationName
    this.DepartmentName = this.currentUser.profile.departmentName
    this.email = this.currentUser.profile.email 
    this.phoneNumber = this.currentUser.profile.phoneNumber 
    let usersPro = await this.userService.getManagersUsers().toPromise();
    this.Managers = <Profile[]>usersPro.responseData;
    this.isAway = this.currentUser.profile.isAway

    if(this.isAway == true){
       this.isAwayVisible = true
       this.Doa = this.currentUser.profile.doa
       this.available = "No"

    }

  }

  
  Submit(): void {
   
    
;
    var obj:any = {}
    obj.DOA = this.DoaId;
    obj.StartDate = this.startDate;
    obj.EndDate = this.EndDate;
    
   this.userService.AssignDOA(obj).subscribe({
    next: (data => {
      
      if (data.responseCode == "00") {
        this.notification.sendMessage({
          message: `Profile Updated successfully.`,
          type: NotificationType.success
        });

      }
      else {

        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.error
        });

      }

    }),
    error: ((error: any) => {
      console.log(error.error);
      ;


      this.notification.sendMessage({
        message: error.error.message,
        type: NotificationType.error
      });
    })

  });

   };
 
   
 
  
}
